/* eslint-disable no-underscore-dangle */
import { useTranslate } from 'hooks/useTranslate';
import { useEffect, useState } from 'react';

import { hasShowDetails } from 'utils/showDetails';
import getTenderOfferRowData from './utils/getTenderOfferRowData';

import BeneficiaryTenderOffersTabRow from './components/BeneficiaryTenderOffersTabRow';

function BeneficiaryTenderOffersTab({ society, beneficiaryAllPlans }) {
  const { t } = useTranslate();

  const [rows, setRows] = useState([]);
  const [currentTenderOffers, setCurrentTenderOffers] = useState([]);

  useEffect(() => {
    if (currentTenderOffers?.length) {
      setRows(
        currentTenderOffers?.map(
          (
            { tenderOfferData: tenderOffer, beneficiaryData: beneficiary },
            index
          ) => {
            const {
              units,
              totalPriceUnits,
              soldUnits,
              totalPriceSoldUnits,
              netAmount,
              status,
            } = getTenderOfferRowData({ tenderOffer, beneficiary });

            return (
              <BeneficiaryTenderOffersTabRow
                index={index + 1}
                key={tenderOffer._id}
                rowKey={tenderOffer._id}
                units={units}
                totalPriceUnits={totalPriceUnits}
                soldUnits={soldUnits}
                totalPriceSoldUnits={totalPriceSoldUnits}
                status={status}
                societyId={society.societyId}
                tenderOfferId={tenderOffer._id}
                beneficiaryId={beneficiary._id}
                retentionPercent={tenderOffer?.retentionPercent || 0}
                netAmount={netAmount}
              />
            );
          }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTenderOffers]);

  useEffect(() => {
    if (beneficiaryAllPlans.length) {
      const allTenderOffers = beneficiaryAllPlans
        .map((b) =>
          b.tenderOffers?.map((tenderOffer) => ({
            tenderOfferData: tenderOffer,
            beneficiaryData: b,
          }))
        )
        ?.flat()
        ?.filter((b) => b?.tenderOfferData);

      setCurrentTenderOffers(allTenderOffers);

      if (hasShowDetails()) {
        console.log('cclog ', { beneficiaryAllPlans, allTenderOffers }); // eslint-disable-line no-console
      }
    }
  }, [beneficiaryAllPlans]);

  return (
    <div className="card-inner">
      <div className="nk-block-head">
        <div className="nk-block-between g-3">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{t('Transactions')}</h4>
            <div className="nk-block-des">
              <p>{t('TenderOffersAndTransactionsDetails')}</p>
            </div>
          </div>
        </div>
      </div>

      {rows?.length ? (
        <>
          <div className="nk-block nk-block-lg">
            <div className="card card-bordered card-preview">
              <table className="table table-striped" id="consolidationTable">
                <thead>
                  <tr>
                    <th scope="col" className="d-none d-md-table-cell">
                      {t('Nr')}
                    </th>
                    <th scope="col" className="d-none d-md-table-cell">
                      {t('Units')}
                    </th>
                    <th scope="col" className="d-none d-md-table-cell">
                      {t('OfferAmount')}
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      {t('AmountSold')}
                    </th>
                    <th scope="col" className="d-none d-md-table-cell">
                      {t('%Retention')}
                    </th>
                    <th scope="col" className="d-none d-md-table-cell">
                      {t('NetAmount')}
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      {t('SoldUnits')}
                    </th>
                    <th scope="col">{t('Status')}</th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default BeneficiaryTenderOffersTab;
